/**
 * @generated SignedSource<<914b2bd232ae9b28a63077caca2e0375>>
 * @relayHash c5661c307a6a6b9452ae52348abb18fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 98c61d1c6f6ca1e27acf0dbdd2d7537553aeea2b103b90d30c139d099696e05f

import type { ConcreteRequest } from 'relay-runtime';
export type PrivatePageGroupAssignmentsQuery$variables = {
  cloudId?: string | null;
  pageId: string;
};
export type PrivatePageGroupAssignmentsQuery$data = {
  readonly stakeholderComms_getPrivatePageGroupAssignmentsByPageId: {
    readonly assignments: ReadonlyArray<{
      readonly groupId: string;
      readonly groupName: string | null;
    } | null> | null;
  } | null;
};
export type PrivatePageGroupAssignmentsQuery = {
  response: PrivatePageGroupAssignmentsQuery$data;
  variables: PrivatePageGroupAssignmentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
      }
    ],
    "concreteType": "StakeholderCommsPrivatePageGroupAssignmentListResponse",
    "kind": "LinkedField",
    "name": "stakeholderComms_getPrivatePageGroupAssignmentsByPageId",
    "plural": false,
    "selections": [
      {
        "concreteType": "StakeholderCommsPrivatePageGroupAssignment",
        "kind": "LinkedField",
        "name": "assignments",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "groupId"
          },
          {
            "kind": "ScalarField",
            "name": "groupName"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PrivatePageGroupAssignmentsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PrivatePageGroupAssignmentsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "98c61d1c6f6ca1e27acf0dbdd2d7537553aeea2b103b90d30c139d099696e05f",
    "metadata": {},
    "name": "PrivatePageGroupAssignmentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "584e4cfa07803431ded102f872c5af04";

export default node;
